import React, { Fragment, useState, useEffect } from 'react';
import styles from '../styles/components/DashboardTable.module.css';
import arrowLeftIcon from '../assets/arrow_left_blue.svg';
import arrowRightIcon from '../assets/arrow_right_blue.svg';
import useResizeObserver from 'helpers/hooks/useResizeObserver';
import { scrollElement } from 'helpers/dom';

interface TabTextHeader {
  text: string;
  icon?: string;
}
type TabHeader = TabTextHeader | JSX.Element;
interface DashboardTableData {
  tabs: TabHeader[];
  subtabs: TabHeader[];
  onChange: (subtabIndex: number, tabIndex: number) => void;
  headComponent?: JSX.Element;
  initialtab?: number | undefined;
}
const DashboardTable: React.FC<DashboardTableData> = props => {
  const [selectedTab, setSelectedTab] = useState(props.initialtab || 0);
  // const [selectedTab, setSelectedTab] = useState(0);
  const [selectedSubtab, setSelectedSubtab] = useState(0);

  const [showLeftScroll, setShowLeftScroll] = useState(false);
  const [showRightScroll, setShowRightScroll] = useState(false);

  const [tabListRef, tabListWidth] = useResizeObserver();

  const handleScroll = (offset?: number) => {
    const tabList = tabListRef.current;
    if (tabList) {
      const maxScroll = tabList.scrollWidth - tabList.offsetWidth;
      const comingScroll = (tabList.scrollLeft || 0) + (offset || 0);
      setShowRightScroll(comingScroll < maxScroll);
      setShowLeftScroll(comingScroll > 0);
      if (offset) {
        scrollElement(tabListRef.current, offset, 300);
      }
    }
  };
  useEffect(() => {
    if (props.initialtab !== undefined && props.initialtab > 3) {
      handleScroll(400);
    }
  }, [props.initialtab]);

  useEffect(handleScroll, [tabListWidth]);
  return (
    <div className={styles.tabsWrapper}>
      <div className={styles.headerTabs}>
        {showLeftScroll && (
          <div
            className={styles.leftScrollButton}
            onClick={() => handleScroll(-100)}
          >
            <img src={arrowLeftIcon} alt="Scrool Tsbs to left" />
          </div>
        )}
        <div className={styles.scrollableTabs} ref={tabListRef}>
          {props.tabs.map((tab, tabIndex) => (
            <div
              key={`tab-${tabIndex}`}
              className={
                tabIndex === selectedTab ? styles.selectedTab : styles.tab
              }
              onClick={() => {
                setSelectedTab(tabIndex);
                handleTabChange(selectedSubtab, tabIndex, props);
              }}
            >
              {'text' in tab ? (
                <>
                  {tab.icon && <i className="material-icons">{tab.icon}</i>}
                  <span className={styles.tabText}>{tab.text}</span>
                </>
              ) : (
                tab
              )}
            </div>
          ))}
        </div>
        {showRightScroll && (
          <div
            className={styles.rightScrollButton}
            onClick={() => handleScroll(100)}
          >
            <img src={arrowRightIcon} alt="Scrool Tsbs to right" />
          </div>
        )}
      </div>
      <div className={styles.sidebarSubtabs}>
        {props.headComponent}
        {props.subtabs.map((subTab, subtabIndex) => (
          <div
            key={`subtab-${subtabIndex}`}
            className={
              subtabIndex === selectedSubtab
                ? styles.selectedSubtab
                : styles.subtab
            }
            onClick={() => {
              setSelectedSubtab(subtabIndex);
              handleTabChange(subtabIndex, selectedTab, props);
            }}
          >
            {'text' in subTab ? (
              <Fragment>
                {subTab.icon && <i className="material-icons">{subTab.icon}</i>}
                <span className={styles.subtabText}>{subTab.text}</span>
              </Fragment>
            ) : (
              subTab
            )}
          </div>
        ))}
      </div>
      <div className={styles.content}>{props.children}</div>
    </div>
  );
};

function handleTabChange(
  subtabIndex: number,
  tabIndex: number,
  props: DashboardTableData
) {
  props.onChange(subtabIndex, tabIndex);
}
export default DashboardTable;
